
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aC5ZO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bcDqz = parcelRequire("bcDqz");


var $3izAL = parcelRequire("3izAL");


var $kA6Zo = parcelRequire("kA6Zo");


var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");


var $4n1IT = parcelRequire("4n1IT");


var $9DHhW = parcelRequire("9DHhW");


var $ep3mz = parcelRequire("ep3mz");


var $ePExc = parcelRequire("ePExc");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $6S5EB = parcelRequire("6S5EB");


var $jmjWc = parcelRequire("jmjWc");


var $9VtwR = parcelRequire("9VtwR");








var $iMnC5 = parcelRequire("iMnC5");











var $dv6q2 = parcelRequire("dv6q2");


var $uBose = parcelRequire("uBose");

const $f0ec2e1e638ea1ae$export$5baa88db8a182af5 = (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { index: index, participant: participant, contentMode: contentMode, contentType: contentType, contentId: contentId, isSingleParticipant: isSingleParticipant, isEligibleForEmptyPresenceDialog: isEligibleForEmptyPresenceDialog, toggleEmptyPresenceDialog: toggleEmptyPresenceDialog, avatarProps: avatarProps, analyticSource: analyticSource } = t0;
    const { id: id } = participant;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const t1 = participant;
    let t2;
    if ($[0] !== contentMode || $[1] !== contentType || $[2] !== t1) {
        t2 = {
            contentType: contentType,
            contentMode: contentMode,
            participant: t1
        };
        $[0] = contentMode;
        $[1] = contentType;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const { isScrollToFeatureEnabled: isScrollToFeatureEnabled, isEligibleToScroll: isEligibleToScroll, scrollToTelepointer: scrollToTelepointer } = (0, $dv6q2.useScrollToTelepointer)(t2);
    let t3;
    if ($[4] !== analyticSource || $[5] !== contentId || $[6] !== contentMode || $[7] !== contentType || $[8] !== createAnalyticsEvent || $[9] !== isEligibleForEmptyPresenceDialog || $[10] !== isEligibleToScroll || $[11] !== isScrollToFeatureEnabled || $[12] !== isSingleParticipant || $[13] !== participant.onClick || $[14] !== scrollToTelepointer || $[15] !== toggleEmptyPresenceDialog) {
        t3 = ()=>{
            if (isSingleParticipant) return isEligibleForEmptyPresenceDialog ? toggleEmptyPresenceDialog : undefined;
            if (isEligibleToScroll) return ()=>{
                const isScrollSuccessful = scrollToTelepointer();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        source: analyticSource,
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "presenceAvatarButton",
                        product: "confluence",
                        attributes: {
                            contentId: contentId,
                            contentType: contentType,
                            contentMode: contentMode,
                            isScrollToFeatureEnabled: isScrollToFeatureEnabled,
                            isEligibleToScroll: isEligibleToScroll,
                            isScrollSuccessful: isScrollSuccessful
                        }
                    }
                }).fire();
            };
            return participant?.onClick;
        };
        $[4] = analyticSource;
        $[5] = contentId;
        $[6] = contentMode;
        $[7] = contentType;
        $[8] = createAnalyticsEvent;
        $[9] = isEligibleForEmptyPresenceDialog;
        $[10] = isEligibleToScroll;
        $[11] = isScrollToFeatureEnabled;
        $[12] = isSingleParticipant;
        $[13] = participant.onClick;
        $[14] = scrollToTelepointer;
        $[15] = toggleEmptyPresenceDialog;
        $[16] = t3;
    } else t3 = $[16];
    const getAvatarButtonOnClickHandler = t3;
    const t4 = `box-${id}`;
    const t5 = `avatar-${id}`;
    const t6 = (0, $9VtwR.MAX_GROUP_SIZE) - index;
    const t7 = `team-presence-avatar-${index}`;
    let t8;
    if ($[17] !== getAvatarButtonOnClickHandler) {
        t8 = getAvatarButtonOnClickHandler();
        $[17] = getAvatarButtonOnClickHandler;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== avatarProps || $[20] !== contentId || $[21] !== contentMode || $[22] !== contentType || $[23] !== isEligibleToScroll || $[24] !== isScrollToFeatureEnabled || $[25] !== participant || $[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uBose.PresenceAvatar), {
            ...avatarProps,
            participant: participant,
            contentId: contentId,
            contentMode: contentMode,
            contentType: contentType,
            key: t5,
            stackIndex: t6,
            testId: t7,
            onClick: t8,
            isEligibleToScroll: isEligibleToScroll,
            isScrollToFeatureEnabled: isScrollToFeatureEnabled
        });
        $[19] = avatarProps;
        $[20] = contentId;
        $[21] = contentMode;
        $[22] = contentType;
        $[23] = isEligibleToScroll;
        $[24] = isScrollToFeatureEnabled;
        $[25] = participant;
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== t4 || $[32] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            padding: (0, $9wGTI.fg)("platform-avatar-group-spacing-fix") ? "space.0" : "space.025",
            key: t4,
            "data-vc": "presence-avatar"
        }, t9);
        $[31] = t4;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
};



const $012cae68941ce2ca$var$NoCollaboratorsDialog = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xe4Dq",
    name: "NoCollaboratorsDialog",
    loader: async ()=>(await (parcelRequire("8ISxc"))).NoCollaboratorsDialog
});

const $012cae68941ce2ca$var$PresenceMenuWithGuest = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8nVZu",
    name: "PresenceMenuWithGuest",
    loader: async ()=>(await (parcelRequire("kQDHo"))).PresenceMenuWithGuest
});
const $012cae68941ce2ca$var$i18n = (0, $kSwu1.defineMessages)({
    overflowLabel: {
        id: "team-presence.avatar-group.overflow-label",
        defaultMessage: "Overflow menu"
    },
    blogpostLandmark: {
        id: "team-presence.avatar-group.blogpost-landmark",
        defaultMessage: "Active people on blog post"
    },
    pageLandmark: {
        id: "team-presence.avatar-group.page-landmark",
        defaultMessage: "Active people on page"
    }
});
const $012cae68941ce2ca$var$popupContainerStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'radius.small',
    position: 'relative',
    width: '360px'
});
const $012cae68941ce2ca$var$editObjectHeaderStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0'
});
const $012cae68941ce2ca$var$overflowMoreStyles = (0, $buxP3.xcss)({
    padding: 'space.075',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    backgroundColor: 'color.background.accent.gray.subtler',
    borderRadius: 'radius.full',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    font: 'font.heading.xxsmall',
    ':hover': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
        backgroundColor: 'color.background.accent.gray.subtler.hovered'
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
        backgroundColor: 'color.background.accent.gray.subtler.pressed'
    }
});
const $012cae68941ce2ca$var$moreActiveStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
// Base styles for indicator - margin will be conditionally applied based on feature gate
const $012cae68941ce2ca$var$indicatorBaseStyles = (0, $buxP3.xcss)({
    minWidth: '28px',
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    borderRadius: 'radius.small',
    ':focus-visible': {
        outlineColor: 'color.border.focused',
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineOffset: 'space.050'
    }
});
// Legacy margin styles (used when platform spacing fix is disabled)
const $012cae68941ce2ca$var$indicatorLegacyMarginStyles = (0, $buxP3.xcss)({
    margin: 'space.025'
});
const $012cae68941ce2ca$var$indicatorOverflowStyles = (0, $buxP3.xcss)({
    minWidth: '35px',
    maxWidth: '35px'
});
const $012cae68941ce2ca$export$fc163eae181faed4 = (t0)=>{
    const $ = (0, $bDgLe.c)(82);
    const { contentId: contentId, contentMode: contentMode, contentType: contentType, analyticSource: analyticSource, popupOpen: popupOpen, participants: participants, totalParticipants: totalParticipants } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6S5EB.isExternalShareRequest)();
        $[0] = t1;
    } else t1 = $[0];
    const isExternal = t1;
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(popupOpen || false);
    const [isShareDialogOpen, setIsShareDialogOpen] = (0, $cozmU.useState)(false);
    let t2;
    if ($[1] !== isGuest || $[2] !== isLoggedIn || $[3] !== participants.length) {
        t2 = ()=>participants.length === 1 && isLoggedIn && !isGuest && !isExternal;
        $[1] = isGuest;
        $[2] = isLoggedIn;
        $[3] = participants.length;
        $[4] = t2;
    } else t2 = $[4];
    const isEligibleForEmptyPresenceDialog = t2;
    let t3;
    if ($[5] !== isPopupOpen || $[6] !== participants.length) {
        t3 = ()=>{
            if (isPopupOpen && participants.length > 1 && participants.length <= (0, $9VtwR.MAX_GROUP_SIZE)) setIsPopupOpen(false);
        };
        $[5] = isPopupOpen;
        $[6] = participants.length;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== isPopupOpen || $[9] !== participants) {
        t4 = [
            isPopupOpen,
            participants
        ];
        $[8] = isPopupOpen;
        $[9] = participants;
        $[10] = t4;
    } else t4 = $[10];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[11] !== contentId || $[12] !== contentMode || $[13] !== contentType || $[14] !== createAnalyticsEvent) {
        t5 = (analyticsTriggerSource)=>{
            setIsPopupOpen(false);
            setIsShareDialogOpen(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: analyticsTriggerSource,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "presenceShare",
                    attributes: {
                        contentId: contentId,
                        contentMode: contentMode,
                        contentType: contentType,
                        shareDialog: "v2"
                    }
                }
            }).fire();
        };
        $[11] = contentId;
        $[12] = contentMode;
        $[13] = contentType;
        $[14] = createAnalyticsEvent;
        $[15] = t5;
    } else t5 = $[15];
    const handleShareClick = t5;
    let t6;
    if ($[16] !== analyticSource || $[17] !== contentId || $[18] !== contentMode || $[19] !== contentType || $[20] !== createAnalyticsEvent || $[21] !== isPopupOpen) {
        t6 = ()=>{
            setIsPopupOpen($012cae68941ce2ca$var$_temp);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: analyticSource,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "singlePresenceAvatarGroup",
                    product: "confluence",
                    attributes: {
                        contentId: contentId,
                        contentMode: contentMode,
                        contentType: contentType,
                        toggle: isPopupOpen ? "close" : "open"
                    }
                }
            }).fire();
        };
        $[16] = analyticSource;
        $[17] = contentId;
        $[18] = contentMode;
        $[19] = contentType;
        $[20] = createAnalyticsEvent;
        $[21] = isPopupOpen;
        $[22] = t6;
    } else t6 = $[22];
    const toggleEmptyPresenceDialog = t6;
    const isSingleParticipant = Boolean(participants && totalParticipants === 1);
    let t7;
    if ($[23] !== analyticSource || $[24] !== contentId || $[25] !== contentMode || $[26] !== contentType || $[27] !== createAnalyticsEvent) {
        t7 = (e, number)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: analyticSource,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "presenceAvatarGroupMoreButton",
                    product: "confluence",
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode,
                        number: number
                    }
                }
            }).fire();
            setIsPopupOpen($012cae68941ce2ca$var$_temp2);
            e.stopPropagation();
        };
        $[23] = analyticSource;
        $[24] = contentId;
        $[25] = contentMode;
        $[26] = contentType;
        $[27] = createAnalyticsEvent;
        $[28] = t7;
    } else t7 = $[28];
    const onMoreClick = t7;
    let t8;
    if ($[29] !== isSingleParticipant) {
        t8 = ()=>isSingleParticipant ? "no-collaborators-dialog" : "presence-menu";
        $[29] = isSingleParticipant;
        $[30] = t8;
    } else t8 = $[30];
    const getTriggerId = t8;
    const triggerId = getTriggerId();
    let t9;
    if ($[31] !== contentId || $[32] !== contentMode || $[33] !== contentType || $[34] !== handleShareClick || $[35] !== spaceKey || $[36] !== triggerId) {
        t9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($012cae68941ce2ca$var$NoCollaboratorsDialog, {
                contentId: contentId,
                contentMode: contentMode,
                contentType: contentType,
                spaceKey: spaceKey || "",
                onShareClick: handleShareClick,
                testId: triggerId
            });
        $[31] = contentId;
        $[32] = contentMode;
        $[33] = contentType;
        $[34] = handleShareClick;
        $[35] = spaceKey;
        $[36] = triggerId;
        $[37] = t9;
    } else t9 = $[37];
    const renderNoCollaboratorsDialog = t9;
    let t10;
    if ($[38] !== contentId || $[39] !== contentMode || $[40] !== contentType || $[41] !== participants || $[42] !== totalParticipants) {
        t10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($012cae68941ce2ca$var$PresenceMenuWithGuest, {
                contentId: contentId,
                contentType: contentType,
                contentMode: contentMode,
                participants: participants,
                totalParticipants: totalParticipants
            });
        $[38] = contentId;
        $[39] = contentMode;
        $[40] = contentType;
        $[41] = participants;
        $[42] = totalParticipants;
        $[43] = t10;
    } else t10 = $[43];
    const renderPresenceMenu = t10;
    let t11;
    if ($[44] !== isSingleParticipant || $[45] !== renderNoCollaboratorsDialog || $[46] !== renderPresenceMenu) {
        const getPopUpContent = ()=>isSingleParticipant ? renderNoCollaboratorsDialog() : renderPresenceMenu();
        t11 = getPopUpContent();
        $[44] = isSingleParticipant;
        $[45] = renderNoCollaboratorsDialog;
        $[46] = renderPresenceMenu;
        $[47] = t11;
    } else t11 = $[47];
    const PopupContent = t11;
    const overflowParticipantCount = totalParticipants - (0, $9VtwR.MAX_GROUP_SIZE) + 1;
    let t12;
    if ($[48] !== contentType || $[49] !== formatMessage) {
        t12 = contentType === "blogpost" ? formatMessage($012cae68941ce2ca$var$i18n.blogpostLandmark) : formatMessage($012cae68941ce2ca$var$i18n.pageLandmark);
        $[48] = contentType;
        $[49] = formatMessage;
        $[50] = t12;
    } else t12 = $[50];
    const landmarkRegionLabel = t12;
    const isEditObjectHeader = contentMode === "edit" || contentMode === "live";
    let t13;
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
        });
        $[51] = t13;
    } else t13 = $[51];
    let t14;
    if ($[52] !== contentId || $[53] !== contentType || $[54] !== isShareDialogOpen || $[55] !== participants.length) {
        t14 = participants.length === 1 && isShareDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ePExc.ShareAndRestrictDialogController), {
            contentId: contentId,
            contentType: contentType,
            allowRestrictions: true,
            pageModes: "view",
            refetchButtonData: $012cae68941ce2ca$var$_temp3,
            onClose: ()=>{
                setIsShareDialogOpen(false);
            },
            isUnpublishedDraft: false
        });
        $[52] = contentId;
        $[53] = contentType;
        $[54] = isShareDialogOpen;
        $[55] = participants.length;
        $[56] = t14;
    } else t14 = $[56];
    let t15;
    if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>setIsPopupOpen(false);
        $[57] = t15;
    } else t15 = $[57];
    let t16;
    if ($[58] !== PopupContent) {
        t16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $012cae68941ce2ca$var$popupContainerStyles
            }, PopupContent);
        $[58] = PopupContent;
        $[59] = t16;
    } else t16 = $[59];
    let t17;
    if ($[60] !== analyticSource || $[61] !== contentId || $[62] !== contentMode || $[63] !== contentType || $[64] !== formatMessage || $[65] !== isEditObjectHeader || $[66] !== isEligibleForEmptyPresenceDialog || $[67] !== isPopupOpen || $[68] !== isSingleParticipant || $[69] !== landmarkRegionLabel || $[70] !== onMoreClick || $[71] !== overflowParticipantCount || $[72] !== participants || $[73] !== toggleEmptyPresenceDialog) {
        t17 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                ...triggerProps,
                paddingInline: "space.050",
                "aria-label": landmarkRegionLabel,
                role: "region",
                xcss: isEditObjectHeader && $012cae68941ce2ca$var$editObjectHeaderStyles,
                "data-vc": "presence-avatar-group"
            }, (0, $9wGTI.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
                appearance: "stack",
                size: "small",
                maxCount: (0, $9VtwR.MAX_GROUP_SIZE),
                data: participants,
                testId: "presence-avatar-group",
                label: landmarkRegionLabel,
                borderColor: "var(--ds-background-neutral, #0515240F)",
                onMoreClick: (e_0)=>onMoreClick(e_0, overflowParticipantCount),
                shouldPopupRenderToParent: false,
                isTooltipDisabled: true,
                overrides: {
                    Avatar: {
                        render: (_, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                                alignItems: "center"
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0ec2e1e638ea1ae$export$5baa88db8a182af5), {
                                index: index,
                                participant: participants[index],
                                contentMode: contentMode,
                                contentType: contentType,
                                contentId: contentId,
                                isSingleParticipant: isSingleParticipant,
                                isEligibleForEmptyPresenceDialog: isEligibleForEmptyPresenceDialog(),
                                toggleEmptyPresenceDialog: toggleEmptyPresenceDialog,
                                avatarProps: props,
                                analyticSource: analyticSource
                            }))
                    },
                    MoreIndicator: {
                        render: (__0, t18)=>{
                            const { buttonProps: buttonProps, isActive: __, borderColor: ___, ...rest } = t18;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                                type: "submit",
                                ...buttonProps,
                                ...rest,
                                padding: (0, $9wGTI.fg)("platform-avatar-group-spacing-fix") ? "space.0" : "space.025",
                                onClick: rest.onClick,
                                xcss: [
                                    $012cae68941ce2ca$var$indicatorBaseStyles,
                                    !(0, $9wGTI.fg)("platform-avatar-group-spacing-fix") && $012cae68941ce2ca$var$indicatorLegacyMarginStyles,
                                    overflowParticipantCount > 100 && $012cae68941ce2ca$var$indicatorOverflowStyles
                                ],
                                testId: rest.testId,
                                "data-vc": "presence-overflow",
                                "aria-label": formatMessage($012cae68941ce2ca$var$i18n.overflowLabel)
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                                xcss: [
                                    $012cae68941ce2ca$var$overflowMoreStyles,
                                    isPopupOpen && $012cae68941ce2ca$var$moreActiveStyles
                                ]
                            }, overflowParticipantCount));
                        }
                    }
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
                appearance: "stack",
                size: "small",
                maxCount: (0, $9VtwR.MAX_GROUP_SIZE),
                data: participants,
                testId: "presence-avatar-group",
                label: landmarkRegionLabel,
                borderColor: "var(--ds-background-neutral, #0515240F)",
                onMoreClick: (e_1)=>onMoreClick(e_1, overflowParticipantCount),
                shouldPopupRenderToParent: false,
                isTooltipDisabled: true,
                overrides: {
                    Avatar: {
                        render: (__1, props_0, index_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                                alignItems: "center",
                                key: `PresenceAvatarButton-${index_0}`
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0ec2e1e638ea1ae$export$5baa88db8a182af5), {
                                index: index_0,
                                participant: participants[index_0],
                                contentMode: contentMode,
                                contentType: contentType,
                                contentId: contentId,
                                isSingleParticipant: isSingleParticipant,
                                isEligibleForEmptyPresenceDialog: isEligibleForEmptyPresenceDialog(),
                                toggleEmptyPresenceDialog: toggleEmptyPresenceDialog,
                                avatarProps: props_0,
                                analyticSource: analyticSource
                            }))
                    },
                    MoreIndicator: {
                        render: (__2, t19)=>{
                            const { buttonProps: buttonProps_0, isActive: ___0, borderColor: ____0, ...rest_0 } = t19;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                                type: "submit",
                                ...buttonProps_0,
                                ...rest_0,
                                padding: (0, $9wGTI.fg)("platform-avatar-group-spacing-fix") ? "space.0" : "space.025",
                                onClick: rest_0.onClick,
                                xcss: [
                                    $012cae68941ce2ca$var$indicatorBaseStyles,
                                    !(0, $9wGTI.fg)("platform-avatar-group-spacing-fix") && $012cae68941ce2ca$var$indicatorLegacyMarginStyles,
                                    overflowParticipantCount > 100 && $012cae68941ce2ca$var$indicatorOverflowStyles
                                ],
                                testId: rest_0.testId,
                                "data-vc": "presence-overflow",
                                "aria-label": formatMessage($012cae68941ce2ca$var$i18n.overflowLabel)
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                                xcss: [
                                    $012cae68941ce2ca$var$overflowMoreStyles,
                                    isPopupOpen && $012cae68941ce2ca$var$moreActiveStyles
                                ]
                            }, overflowParticipantCount));
                        }
                    }
                }
            }));
        $[60] = analyticSource;
        $[61] = contentId;
        $[62] = contentMode;
        $[63] = contentType;
        $[64] = formatMessage;
        $[65] = isEditObjectHeader;
        $[66] = isEligibleForEmptyPresenceDialog;
        $[67] = isPopupOpen;
        $[68] = isSingleParticipant;
        $[69] = landmarkRegionLabel;
        $[70] = onMoreClick;
        $[71] = overflowParticipantCount;
        $[72] = participants;
        $[73] = toggleEmptyPresenceDialog;
        $[74] = t17;
    } else t17 = $[74];
    let t18;
    if ($[75] !== isPopupOpen || $[76] !== t16 || $[77] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: isPopupOpen,
            onClose: t15,
            placement: "bottom-end",
            content: t16,
            trigger: t17
        });
        $[75] = isPopupOpen;
        $[76] = t16;
        $[77] = t17;
        $[78] = t18;
    } else t18 = $[78];
    let t19;
    if ($[79] !== t14 || $[80] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t13, t14, t18);
        $[79] = t14;
        $[80] = t18;
        $[81] = t19;
    } else t19 = $[81];
    return t19;
};
function $012cae68941ce2ca$var$_temp(isPopupOpenState) {
    return !isPopupOpenState;
}
function $012cae68941ce2ca$var$_temp2(isPopupOpenState_0) {
    return !isPopupOpenState_0;
}
function $012cae68941ce2ca$var$_temp3() {}
module.exports["PresenceAvatarGroup"] = $012cae68941ce2ca$export$fc163eae181faed4;

});

parcelRegister("dv6q2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jbOus = parcelRequire("jbOus");


var $kDhla = parcelRequire("kDhla");


var $e4o8D = parcelRequire("e4o8D");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $lkApp = parcelRequire("lkApp");

const $99b335d011a83318$var$getTelepointerEl = (sessionId)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector(`[${(0, $jbOus.TELEPOINTER_DATA_SESSION_ID_ATTR)}="${sessionId}"]`);
};
const $99b335d011a83318$export$3e8e4ca69eec4635 = ({ contentType: contentType, contentMode: contentMode, participant: participant })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const [{ fullPageEditorPresetAPI: fullPageEditorPresetAPI }] = (0, $kDhla.useFullPageEditorApi)();
    // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
    const participantSessions = participant?.sessions ?? {};
    const [activeTelepointer] = (0, $lkApp.useActiveTelepointerBySessions)(participantSessions);
    const activeTelepointerPos = activeTelepointer?.selection.head;
    const activeSessionId = activeTelepointer?.sessionId;
    const sessionData = participantSessions[activeSessionId];
    const telepointerEl = isServerPlaceholder ? null : $99b335d011a83318$var$getTelepointerEl(activeSessionId);
    // Keep the optional chaning until we have a stricter "PresenceSessionData"
    const activity = sessionData?.activity;
    const isScrollToFeatureEnabled = // This feature is only available for live docs (for "editing" users), and pages and blogposts in edit mode
    ((contentType === 'page' || contentType === 'blogpost') && contentMode === 'edit' || contentMode === 'live' && activity !== 'viewer') && // Current user won't have the onClick handler for scroll
    !participant?.isCurrentUser;
    const isEligibleToScroll = isScrollToFeatureEnabled && // This is to filter out cases like where we have a user but no telepointer data; e.g. no focus on the doc
    activeTelepointerPos !== undefined && activeSessionId !== undefined && // Even if we have telepointer data, that doesn't guarantee the telepointer will be in the DOM.
    // e.g. platform_editor_no_telecursor_on_live_doc_init,
    telepointerEl !== null;
    const observerRef = (0, $cozmU.useRef)(null);
    const timeoutRef = (0, $cozmU.useRef)(null);
    const killObserver = ()=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // Abort ongoing experience in case it's stuck in an unexpected state
            const expState = experienceTracker.getExperienceState((0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE));
            if (expState?.attributes?.sessionId === activeSessionId && !expState?.hasStopped) experienceTracker.abort({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                reason: 'useScrollToTelepointer unmounted'
            });
        };
    }, [
        activeSessionId,
        experienceTracker
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            killObserver();
        };
    }, []);
    const scrollToTelepointer = (0, $cozmU.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                sessionId: activeSessionId,
                activity: activity
            }
        });
        try {
            killObserver();
            const scrollToPos = fullPageEditorPresetAPI?.core.actions.scrollToPos;
            const nudgeTelepointer = fullPageEditorPresetAPI?.collabEdit?.commands.nudgeTelepointer;
            if (!isEligibleToScroll || !scrollToPos) {
                experienceTracker.fail({
                    name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                    error: new Error('Eligibility checks failed'),
                    attributes: {
                        isEligibleToScroll: isEligibleToScroll,
                        isScrollToPosDefined: scrollToPos !== undefined
                    }
                });
                return false;
            }
            const isScrollSuccessful = scrollToPos(Number(activeTelepointerPos), {
                behavior: 'smooth',
                block: 'center'
            });
            if (isScrollSuccessful && nudgeTelepointer && telepointerEl !== null) {
                // We don't run this callback in SSR, so no need to escape it with an isSSR check
                // eslint-disable-next-line no-restricted-syntax
                observerRef.current = new IntersectionObserver(([entry])=>{
                    if (entry.isIntersecting) {
                        fullPageEditorPresetAPI?.core.actions.execute(nudgeTelepointer(activeSessionId));
                        killObserver();
                    }
                });
                observerRef.current.observe(telepointerEl);
                // Edge case: Set a timeout to disconnect the observer if intersection doesn't happen
                // 5000ms is an arbitrary time and can be reduced.
                timeoutRef.current = setTimeout(()=>{
                    killObserver();
                }, 5000);
            }
            if (!isScrollSuccessful) experienceTracker.fail({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                error: new Error('Scroll is not successful'),
                attributes: {
                    isNudgeTelepointerDefined: nudgeTelepointer !== undefined,
                    hasValidTelepointerElement: telepointerEl !== null
                }
            });
            else experienceTracker.succeed({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE)
            });
            return isScrollSuccessful;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                error: error
            });
            return false;
        }
    }, [
        activeSessionId,
        activeTelepointerPos,
        activity,
        contentMode,
        contentType,
        fullPageEditorPresetAPI,
        experienceTracker,
        isEligibleToScroll,
        telepointerEl
    ]);
    return {
        isScrollToFeatureEnabled: isScrollToFeatureEnabled,
        isEligibleToScroll: isEligibleToScroll,
        scrollToTelepointer: scrollToTelepointer
    };
};
module.exports["useScrollToTelepointer"] = $99b335d011a83318$export$3e8e4ca69eec4635;

});

parcelRegister("uBose", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $lpNn5 = parcelRequire("lpNn5");


var $kA6Zo = parcelRequire("kA6Zo");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9VtwR = parcelRequire("9VtwR");

const $09acd215ab95c7d5$var$i18n = (0, $kSwu1.defineMessages)({
    editing: {
        id: "team-presence.menu.editing",
        defaultMessage: "Editing"
    },
    viewing: {
        id: "team-presence.menu.viewing",
        defaultMessage: "Viewing"
    },
    clickToFind: {
        id: "team-presence.menu.click-to-find",
        defaultMessage: "Click to find"
    },
    clickToFindNotAvailable: {
        id: "team-presence.menu.click-to-find-not-available",
        defaultMessage: "Inactive"
    },
    clickToFollow: {
        id: "team-presence.menu.click-to-follow",
        defaultMessage: "Click to follow"
    }
});
const $09acd215ab95c7d5$var$containerStyles = (0, $buxP3.xcss)({
    position: 'relative'
});
const $09acd215ab95c7d5$var$avatarBadgeStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    bottom: '-2px',
    right: '-2px',
    height: '12px',
    width: '12px',
    borderRadius: 'radius.small',
    color: 'color.text.inverse',
    // TODO: This will need to be swapped for the foregroundColor, based on sessionId
    boxShadow: 'elevation.shadow.overflow',
    fontWeight: 'font.weight.semibold',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '10px',
    zIndex: 'card',
    userSelect: 'none'
});
const $09acd215ab95c7d5$var$tooltipTextStyles = (0, $buxP3.xcss)({
    textAlign: 'center'
});
const $09acd215ab95c7d5$var$EditorAvatarBadge = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { borderColor: backgroundColor, badgeTextColor: badgeTextColor, name: name } = t0;
    let t1;
    if ($[0] !== name) {
        t1 = name?.substring(0, 1);
        $[0] = name;
        $[1] = t1;
    } else t1 = $[1];
    const firstInitial = t1;
    const t2 = backgroundColor;
    const t3 = badgeTextColor;
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = (0, $buxP3.xcss)({
            backgroundColor: t2,
            color: t3
        });
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== t4) {
        t5 = [
            $09acd215ab95c7d5$var$avatarBadgeStyles,
            t4
        ];
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== firstInitial) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: "editor-avatar-badge-initial",
            as: "span"
        }, firstInitial);
        $[7] = firstInitial;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            testId: "editor-avatar-badge",
            alignItems: "center",
            justifyContent: "center",
            xcss: t5
        }, t6);
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
};
const $09acd215ab95c7d5$var$TooltipText = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $09acd215ab95c7d5$var$tooltipTextStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $09acd215ab95c7d5$export$9b9667d767e90372 = (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    let avatarProps;
    let contentType;
    let isEligibleToScroll;
    let isScrollToFeatureEnabled;
    let participant;
    if ($[0] !== t0) {
        const { contentMode: _contentMode, contentId: _contentId, contentType: t1, isEligibleToScroll: t2, isScrollToFeatureEnabled: t3, participant: t4, ...t5 } = t0;
        contentType = t1;
        isEligibleToScroll = t2;
        isScrollToFeatureEnabled = t3;
        participant = t4;
        avatarProps = t5;
        $[0] = t0;
        $[1] = avatarProps;
        $[2] = contentType;
        $[3] = isEligibleToScroll;
        $[4] = isScrollToFeatureEnabled;
        $[5] = participant;
    } else {
        avatarProps = $[1];
        contentType = $[2];
        isEligibleToScroll = $[3];
        isScrollToFeatureEnabled = $[4];
        participant = $[5];
    }
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { activity: activity, color: participantColor, id: id, isCurrentUser: isCurrentUser, name: name } = participant;
    const displayedSrc = isCurrentUser ? `/wiki/aa-avatar/${id}` : participant.src;
    let t1;
    if ($[6] !== activity || $[7] !== formatMessage) {
        t1 = activity === "editor" ? formatMessage($09acd215ab95c7d5$var$i18n.editing) : formatMessage($09acd215ab95c7d5$var$i18n.viewing);
        $[6] = activity;
        $[7] = formatMessage;
        $[8] = t1;
    } else t1 = $[8];
    const activityText = t1;
    let t2;
    if ($[9] !== activityText || $[10] !== contentType || $[11] !== name) {
        t2 = (0, $9VtwR.isCanvasContentType)(contentType) ? name : `${name} (${activityText})`;
        $[9] = activityText;
        $[10] = contentType;
        $[11] = name;
        $[12] = t2;
    } else t2 = $[12];
    const label = t2;
    let t3;
    if ($[13] !== id || $[14] !== isCurrentUser) {
        t3 = isCurrentUser ? (0, $9VtwR.getCurrentUserColors)() : (0, $9VtwR.getParticipantColors)(id);
        $[13] = id;
        $[14] = isCurrentUser;
        $[15] = t3;
    } else t3 = $[15];
    const colors = t3;
    const borderColor = participantColor ?? colors.backgroundColor;
    let t4;
    if ($[16] !== contentType || $[17] !== isCurrentUser || $[18] !== participant.followCursor) {
        t4 = !isCurrentUser && (0, $9VtwR.isCanvasContentType)(contentType) && participant.followCursor;
        $[16] = contentType;
        $[17] = isCurrentUser;
        $[18] = participant.followCursor;
        $[19] = t4;
    } else t4 = $[19];
    const shouldShowClickToFollow = t4;
    const shouldShowClickToFind = Boolean(isScrollToFeatureEnabled) && participant.activity !== "viewer";
    let t5;
    if ($[20] !== label) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09acd215ab95c7d5$var$TooltipText, null, label);
        $[20] = label;
        $[21] = t5;
    } else t5 = $[21];
    let t6;
    if ($[22] !== shouldShowClickToFollow) {
        t6 = shouldShowClickToFollow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09acd215ab95c7d5$var$TooltipText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09acd215ab95c7d5$var$i18n.clickToFollow));
        $[22] = shouldShowClickToFollow;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== isEligibleToScroll || $[25] !== shouldShowClickToFind) {
        t7 = shouldShowClickToFind && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            justifyContent: "center"
        }, isEligibleToScroll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09acd215ab95c7d5$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $09acd215ab95c7d5$var$i18n.clickToFindNotAvailable));
        $[24] = isEligibleToScroll;
        $[25] = shouldShowClickToFind;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t6, t7);
        $[27] = t5;
        $[28] = t6;
        $[29] = t7;
        $[30] = t8;
    } else t8 = $[30];
    let t9;
    if ($[31] !== avatarProps || $[32] !== borderColor || $[33] !== displayedSrc || $[34] !== label || $[35] !== name) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            ...avatarProps,
            appearance: "circle",
            borderColor: borderColor,
            label: label,
            name: name,
            size: "small",
            src: displayedSrc
        });
        $[31] = avatarProps;
        $[32] = borderColor;
        $[33] = displayedSrc;
        $[34] = label;
        $[35] = name;
        $[36] = t9;
    } else t9 = $[36];
    let t10;
    if ($[37] !== activity || $[38] !== borderColor || $[39] !== colors || $[40] !== name) {
        t10 = activity === "editor" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09acd215ab95c7d5$var$EditorAvatarBadge, {
            borderColor: borderColor,
            badgeTextColor: colors.textColor,
            name: name
        });
        $[37] = activity;
        $[38] = borderColor;
        $[39] = colors;
        $[40] = name;
        $[41] = t10;
    } else t10 = $[41];
    let t11;
    if ($[42] !== t10 || $[43] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            direction: "column",
            alignItems: "center",
            gap: "space.0",
            xcss: $09acd215ab95c7d5$var$containerStyles
        }, t9, t10);
        $[42] = t10;
        $[43] = t9;
        $[44] = t11;
    } else t11 = $[44];
    let t12;
    if ($[45] !== t11 || $[46] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t8
        }, t11);
        $[45] = t11;
        $[46] = t8;
        $[47] = t12;
    } else t12 = $[47];
    return t12;
};
module.exports["PresenceAvatar"] = $09acd215ab95c7d5$export$9b9667d767e90372;

});

parcelRegister("8ISxc", function(module, exports) {

let $659cbc36a7ae465a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $659cbc36a7ae465a$var$load("1Kk1a").then(()=>parcelRequire('5ZJn7'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("kQDHo", function(module, exports) {

let $f2d7755765f40693$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2d7755765f40693$var$load("9lYw8").then(()=>parcelRequire('23mW9'));

});


//# sourceMappingURL=PagePresence.7f31370d.js.map
